import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  EventEmitter,
  Output,
  ViewChild,
  ElementRef,
  OnDestroy,
} from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MatAutocompleteModule,
  MatAutocompleteSelectedEvent,
} from '@angular/material/autocomplete';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AutocompleteItem } from '../../../common/models/common/autocomplete/autocomplete-item';
import { TranslateModule } from '@ngx-translate/core';
import { CommonUrlBasedService } from '../../../services/common.url-based.service';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { debounceTime, distinctUntilChanged, Subscription } from 'rxjs';

@Component({
  selector: 'mec-autocomplete',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    FontAwesomeModule,
    TranslateModule,
  ],
  templateUrl: './autocomplete.component.html',
  styleUrls: ['./autocomplete.component.scss'],
})
export class AutocompleteComponent implements OnChanges, OnDestroy {
  @ViewChild('inputAutocomplete') public inputAutocomplete: ElementRef;

  @Input() controlName: string;
  @Input() placeholder?: string;
  @Input() formGroup: FormGroup;
  @Input() hideSearchIcon: boolean;
  @Input() items: AutocompleteItem[];
  @Input() isDynamicList: boolean;
  @Input() size: 'small' | 'medium' | 'large' = 'medium';
  @Output() optionSelectedChange = new EventEmitter<AutocompleteItem>();
  @Output() searchFilterChange = new EventEmitter<string>();

  public filteredItems: AutocompleteItem[] = [];
  public searchIcon = faMagnifyingGlass;

  public subscription: Subscription;

  constructor(private _commonService: CommonUrlBasedService) {}
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['formGroup']) {
      this.filteredItems = this.items;

      this.subscription = this.formGroup.controls[this.controlName].valueChanges
        .pipe(debounceTime(800))
        .pipe(distinctUntilChanged())
        .subscribe((search) => {
          if (this.isDynamicList) {
            this.searchFilterChange.emit(search);
          } else {
            this.filteredItems = this._filter(search);
          }
        });
    }
  }

  public clearInput(): void {
    this.formGroup.controls[this.controlName].setValue('');
    this.inputAutocomplete.nativeElement.focus();
  }

  public optionSelected(event: MatAutocompleteSelectedEvent): void {
    this.optionSelectedChange.emit(event.option.value);
  }

  public displayName(item: AutocompleteItem): string {
    return item && item.title ? item.title : '';
  }

  private _filter(value: string): AutocompleteItem[] {
    if (typeof value !== 'string' || !value) {
      return this.items;
    }

    const filterValue = value?.toLowerCase();

    return this.items.filter((item) =>
      item.title.toLowerCase().includes(filterValue)
    );
  }
}
